exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav {\r\n    line-height: 30px;\r\n    background-color: black;\r\n}\r\n\r\n.usci .lo,\r\n.usci .ncr,\r\n.usci .ccr {\r\n    text-align: center;\r\n    margin: 1px;\r\n}\r\n\r\n.usci .ncr a,\r\n.usci .ccr a {\r\n    background-color: #054795;\r\n    color: white;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    width: 220px;\r\n}\r\n\r\n.usci .lo a {\r\n    background-color: #3dc115;\r\n    color: white;\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    width: 150px;\r\n}\r\n\r\n\r\n.usci .ncr a:hover,\r\n.usci .ccr a:hover {\r\n    opacity: 0.8;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-campaign/usci-home/usci-home.component.css
// module id = ../../../../../src/app/components/usc-campaign/usci-home/usci-home.component.css
// module chunks = main